// Tblist.jsx
import React, { useEffect, useRef } from 'react';
import { Modal, Button } from 'antd';
import FullHeightLayout from './FullHeightLayout';
import { QuestionCircleOutlined } from '@ant-design/icons';
function CustModal(props) {
    const {
        onCancel,
        open,
        onOk,
        title,
        children,
        width = "70vw",
        okText = '确定',
        cancelText = '取消',
        style = {
            maxWidth: '80vw',
            maxHeight: '80vh',
            overflow: 'auto'
        },
        footer = true,
        footerAp = null,
        isloading = false,
        help
    } = props;

    const showHelp=()=>{
        Modal.confirm({
            title:'帮助',
            content: help
        })
    }
    const myFooter=()=>{
        const res = [];
        if(footer){
            res.push(<Button onClick={onCancel} key={'mfbtn1'} style={{ marginRight: 8 }}>{cancelText}</Button>);
            res.push(<Button onClick={onOk} key={'mfbtn2'} type="primary">{okText}</Button>);
        }
        if(footerAp) res.push(footerAp);
        return (<div style={{ display: 'flex', width: '100%', gap: 6, justifyContent: 'flex-end' }}>{res}</div>)
    }
    return (
        <Modal
            isloading={isloading}
            title={ help ? (<div style={{"display":"flex", "width":"calc(100% - 40px)"}}><div style={{"flex":1}}>{title}</div><div onClick={showHelp}><QuestionCircleOutlined /></div></div>) :title}
            open={open}
            onCancel={onCancel}
            onOk={onOk}
            footer={false}
            width={width}
            styles={{
                body: { height: '70vh', overflow: 'hidden', flexDirection: 'column', paddingRight: '10px', ...style }
            }}
            okText={okText}
            cancelText={cancelText}
        >
            <FullHeightLayout
                headerContent={null}
                bodyContent={children}
                footerContent={myFooter()}
            />
        </Modal>
    );
}

export default CustModal;